import React, { useState, useRef } from 'react';
import { Otsikko } from './Otsikko';

export function KalustomestariLee() {
  const [visible, setVisible] = useState(false);
  const titleRef = useRef();

  return (
    <div className="container vitsit">
      <div ref={titleRef}>
        <Otsikko visible={visible} setVisible={setVisible}>
          Kalustomestari Lee -vitsi
        </Otsikko>
      </div>

      <p>
        Oli kulunut vuosi siitä, kun vaihto-oppilas Lee oli liittynyt
        Polyteknikkojen Orkesteriin. PO:n ansiosta vaihto oli myös venähtänyt
        toiselle lukuvuodelle.
        {!visible ? (
          ' ...'
        ) : (
          <React.Fragment>
            {' '}
            Leestä oli edellisen kiertueen huume- ja
            sukupuolisiveellisyyssyytteiden jälkeen tullut arvostettu
            kalustomestari, jonka maine oli kiirinyt aina Otaniemen kärkeen
            asti.
          </React.Fragment>
        )}
      </p>

      {!visible && (
        <p className="lisaa">
          <button onClick={(e) => setVisible(true)} className="text-button">
            Lue lisää...
          </button>
        </p>
      )}

      {visible && (
        <React.Fragment>
          <p>
            Leen ura lyömäsoittajana oli niin ikään saavuttanut huippunsa.
            Tutuksi olivat vuoden ohjelmistojen aikana tulleet niin räikkä,
            piiska, tamtam kuin isorumpukin. Tällä kertaa Lee istutettiin
            triangelin eteen. Lee katsoi stemmaa ja tuumasi, että taukoa oli
            huomattavasti enemmän kuin soittamista. Tämä tarkoitti, että hänellä
            olisi kosolti aikaa käydä tapansa mukaan keventämässä lastiaan
            Smökin WC:ssä ennen triangelin hohtohetkiä.
          </p>
          <p>
            Lee astui koppiin, laittoi oven lukkoon ja antoi mennä. Toimituksen
            jälkeen hän tarttui vielä pöntöllä istuessaan ovenkahvaan
            noustakseen ylös, mutta kahva otti ja lähtikin irti. Myös koko
            lukkopesä vaikutti olevan juntturassa. "Mites minä nyt täältä..."
            hän mutisi orastavan kauhunsekaisin tunnelmin. Housutkin olivat
            vielä puolitangossa. Lee alkoi riuhtoa ovea vimmatusti sen sivuista,
            ja hakkasi sitä nyrkein huutaen samalla apua. Harmiksi salin
            puolella raikui juuri Mahlerin sinfonia, jonka seasta WC:n puolelta
            kuului korkeintaan pientä piipitystä.
          </p>

          <p>
            Lee oli juuri, etumuksen vielä pullottaessa, kiivennyt pöntön päältä
            WC-kopin ylälaitaan poistuakseen sitä kautta, kun WC:n ulko-ovi
            kävi, ja sisään astui pahaa-aavistamaton kakkosviulistifuksi.
            Samalla kopin tukirakenteet pettivät Leen alta, ja kalustomestari
            rojahti WC:n lattialle esitellen kalustoaan. Paikalle pelmahtanut
            fuksi poistui hämmentyneenä WC:stä, olihan hän tietoinen Leen
            kyseenalaisesta maineesta.
          </p>

          <p>
            WC-episodin jälkeen Lee ehti kuin ehtikin triangelin pariin ja
            loppuosa treeneistä sujui varsin mallikkaasti toivoen tosin, että
            kakkosviulisti ei kovin paljoa avautuisi ulkopuolisille näkemästään.
            Leen mielessä oli kuitenkin alkanut itää harmitus
            lyömäsoitinstemmojen taukojen määrästä. "Olen harjoitellut useita
            uusia soittimia, mutta saan soittaa niitä muutaman tahdin verran",
            hän puhisi sektiokaverilleen. Äkkiä hän muisti nähneensä
            kiertuebussissa, kuinka eräs nimeltä mainitsematon seniorisoittaja
            säesti orkesterilaisten laulua hanurillaan koko bussimatkan ajan.
            Leekin päätti kokeilla - olihan hän aina ollut viehtynyt hanurin
            äänestä.
          </p>

          <p>
            Eräänä huhtikuisena lauantaina Lee saapui F-musiikkiin ja sanoi
            myyjälle: "Yksi hanuri, kiitos!", ja poistui liikkeestä kainalossaan
            uutuuttaan kiiltävä punavalkoinen haitari, johon hän käytti kaikki
            huumesotkuista säästyneet rahansa. Nimeltä mainitsematon PO:n
            konkarihanuristi oli vinkannut Leelle Unto Monosen tuotannosta. Sinä
            keväänä Jämeräntaival 3:n asukkaat saivatkin vakituiseksi
            yövieraakseen Satumaa-tangon. Lee oli viehättynyt kappaleen
            poljennosta ja kehittyikin soittamisessa huomattavan nopeasti.
            Orkesteriharrastustakaan ei tarvinnut jättää väliin, sillä
            Waputtimen ohjelmistoon valikoitui anonyymin, soittajille lähetetyn
            kyselyn perusteella Unto Monosen Satumaa, ja Smökin WC-koppien
            ovetkin oli uusittu.
          </p>

          <p>
            Satumaa alkoi sujua jo sangen virtuoottisesti, kun Lee sai
            TV-mainoksesta idean osallistua Kultainen hanuri -kilpailuun. Täten
            hänen uuttera harjoittelunsa ei menisi hukkaan! Kuten Lee
            WC-kopissa, alkoi myös pissa Leen pääkopassa nousta yhä
            korkeammalle, ja hänen orkesterituttunsa alkoivat väsyä jatkuviin
            tarinoihin Kultainen hanuri -kilpailun karsinnoista ja välieristä.
            Heidän onnekseen kilpailun finaali, johon Lee oli Satumaallaan
            päässyt, koitti pian.
          </p>

          <p>
            Tampere-talo, jossa hanurikilpailun finaali pidettiin, näytti Leestä
            valtavan hienolta, olihan hän opinnoissaan juuri keskittynyt
            suomalaiseen postmoderniin arkkitehtuuriin. Lee oli juuri ottamassa
            aulassa selfietä talon suunnittelijoiden Sakari Aartelon ja Esa
            Piirosen nimilaattojen kanssa, kun hän tajusi, että oma
            esiintymisvuoro lähestyi. Mielen valtasi pikku hiljaa arkkitehtuurin
            sijaan vankka voitontahto.
          </p>

          <p>
            Lee kuulutettiin lavalle, ja h-hetki oli käsillä. Leen sormet
            seikkailivat satumaisesti hanurin syvyyksissä, ja yleisökin näytti
            vaikuttuneelta. Hän oli erittäin tyytyväinen suoritukseensa. Pääsy
            finaaliin asti ei kuitenkaan vielä tyydyttänyt Leetä, vaan hän oli
            päässään valmistautunut voittoon, tai vähintäänkin Lasse Pihlajamaa
            -tunnustuspalkintoon, kun kilpailun juontaja ilmoitti toisen
            kierroksen alkamisesta. "Toinen kierros? Mutta enhän minä osaa
            soittaa mitään muuta biisiä...", Lee kauhistui. Hän meni paniikkiin,
            ja soittovuoronsa tultua Lee sai soitettua hanuristaan pelkän
            A-sävelen kutsuen sitä omaksi sävellyksekseen nimeltä "Viritys".
            Tuloksena kilpailusta oli lopulta Vexi Salmi -lohdutuspalkinto. Pian
            kilpailun jälkeen, eikä vähiten erään lörppähuulisen kakkosviulistin
            ansiosta, Otaniemessä alkoi kiertää lentävä lause: harva pöntöllä
            urheilee kuin Untolla pörhei-Lee.
          </p>
          <p className="lisaa">
            <button
              onClick={(e) => {
                setVisible(false);
                if (titleRef) {
                  titleRef.current.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="text-button"
            >
              Lue vähemmän...
            </button>
          </p>
        </React.Fragment>
      )}
    </div>
  );
}
